(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-rerank-ticket"]) return;
  try {
    
  (() => {
    // School-locked variants (e.g. ?view=ucla) fix the email domain: the visitor may
    // type just the local part and we complete it to <prefix>@<domain>. Without JS the
    // input's pattern still forces a full address, so nothing is lost.
    document.querySelectorAll('[data-rerank-email]').forEach((input) => {
      const domain = input.dataset.emailDomain;

      if (!domain) {
        return;
      }

      const complete = () => {
        const value = input.value.trim();

        if (value && !value.includes('@')) {
          input.value = value + '@' + domain;
        }
      };

      input.addEventListener('blur', complete);

      const form = input.form;

      if (form) {
        form.addEventListener('submit', complete, true);
      }
    });
  })();

  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-rerank-gallery]').forEach((gallery) => {
      const track = gallery.querySelector('[data-rerank-track]');
      const dots = Array.from(gallery.querySelectorAll('[data-rerank-dot]'));
      const slides = track ? Array.from(track.children) : [];

      if (!track || slides.length < 2) {
        return;
      }

      let current = 0;
      let timer = null;
      let scrollFrame = null;

      const slideWidth = () => track.clientWidth;

      const setActive = (index) => {
        current = index;
        dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const goTo = (index, smooth) => {
        const next = (index + slides.length) % slides.length;
        track.scrollTo({ left: slideWidth() * next, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
        setActive(next);
      };

      // Keep the active dot in sync while the visitor swipes / scrolls the track.
      track.addEventListener('scroll', () => {
        if (scrollFrame) {
          return;
        }
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = null;
          const width = slideWidth();
          if (!width) {
            return;
          }
          const index = Math.round(track.scrollLeft / width);
          if (index !== current) {
            setActive(index);
          }
        });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.index), true);
          restart();
        });
      });

      const goPrev = gallery.querySelector('[data-rerank-prev]');
      const goNext = gallery.querySelector('[data-rerank-next]');

      if (goPrev) {
        goPrev.addEventListener('click', () => {
          goTo(current - 1, true);
          restart();
        });
      }

      if (goNext) {
        goNext.addEventListener('click', () => {
          goTo(current + 1, true);
          restart();
        });
      }

      const start = () => {
        if (reduceMotion || timer || slides.length < 2) {
          return;
        }
        timer = setInterval(() => {
          // Jump (not smooth) on the last -> first wrap so the carousel doesn't
          // sweep all the way back across every slide.
          const atEnd = current === slides.length - 1;
          goTo(current + 1, !atEnd);
        }, 4500);
      };

      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const restart = () => {
        stop();
        start();
      };

      // Pause auto-play while the visitor interacts (pointer, touch, or keyboard); resume afterwards.
      gallery.addEventListener('pointerenter', stop);
      gallery.addEventListener('pointerleave', start);
      gallery.addEventListener('pointerdown', stop);
      gallery.addEventListener('touchstart', stop, { passive: true });
      gallery.addEventListener('touchend', start, { passive: true });
      gallery.addEventListener('focusin', stop);
      gallery.addEventListener('focusout', start);

      // Re-align to the current slide when the layout width changes (rAF-throttled).
      let resizeFrame = null;
      window.addEventListener('resize', () => {
        if (resizeFrame) {
          return;
        }
        resizeFrame = requestAnimationFrame(() => {
          resizeFrame = null;
          goTo(current, false);
        });
      });

      setActive(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
